import React, { useContext, useState } from 'react'
import { HiMenuAlt4, HiX } from 'react-icons/hi'
import { motion } from 'framer-motion'
import { images } from '../../utilities'

import './Navbar.scss'
import { DarkThemeContext } from '../../utilities/DarkTheme'

const Navbar = () => {
  const [toggle, setToggle] = useState(false)
  const { darkToggle, setDarkToggle } = useContext(DarkThemeContext)
  const navLinkItems = [
    'home',
    'about',
    'work',
    'skills',
    'testimonial',
    'contact',
  ]
  return (
    <nav className='app__navbar dark:bg-gray'>
      <div className='app__navbar-logo'>
        <img src={images.logo} alt='logo' />
      </div>
      <ul className='app__navbar-links'>
        {navLinkItems.map((item, index) => (
          <li className='app__flex p-text' key={index}>
            <div />
            <a className='dark:text-white' href={`#${item}`}>
              {item}
            </a>
          </li>
        ))}
        <li className='app__flex p-text'>
          <label className='toggleDarkBtn'>
            <input type='checkbox' onClick={() => setDarkToggle(!darkToggle)} />
            <span className='slideBtnTg round'></span>
          </label>
        </li>
      </ul>

      <div className='app__navbar-menu dark:bg-slate-800'>
        <HiMenuAlt4 onClick={() => setToggle(true)} />
        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: 'easeOut' }}
            className='dark:bg-slate-800'
          >
            <HiX onClick={() => setToggle(false)} />
            <ul>
              {navLinkItems.map((item, index) => (
                <li key={index}>
                  <a className='dark:text-white' href={`#${item}`}>
                    {item}
                  </a>
                </li>
              ))}
              <li className='app__flex p-text'>
                <label className='toggleDarkBtn'>
                  <input
                    type='checkbox'
                    onClick={() => setDarkToggle(!darkToggle)}
                  />
                  <span className='slideBtnTg round'></span>
                </label>
              </li>
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  )
}

export default Navbar
